const objectItems = {
  label1: 'Calendar',
  label2: 'Actions',
  label3: 'Places',
  label4: 'Map',
  label5: 'Dashboard',
  label6: 'Equipments',
  label7: 'Services',
  label8: 'Third Party Companies',
  label9: 'Users',
  label10: 'Departments',
  label11: 'Equipment Types',
  label12: 'Groups',
  label13: 'Frequencies',
  label14: 'Service Types',
  label15: 'My account',
  label16: 'Support files',
  label17: 'Backups (App)',
  label19: 'Maintenances',
  label18: 'Reports',
  label20: 'Overdue Services',
  label21: 'Schedules Services',
  label22: 'Scheduled Services Calendar',
  label23: 'Settings',
  label24: 'Downloaded Data',
  serviceDrafts: 'Service Drafts',
}

export default objectItems;
